import React, { useEffect, useRef, useState } from "react";
import { FormButton, SpinnerOverlay } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHAreaDel } from "services/services-mia/programa-salud/estructuras/RNHAreaDel";
import { RNHAreaGet } from "services/services-mia/programa-salud/estructuras/RNHAreaGet";

export default function DeleteModal({ row, updateList, closeModal, setterRowSelected }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState();
    const formikRef = useRef();
    
    const getArticulosData = async () => {
        setIsLoading(true);
        // El filtro del Get es `rnhAreaCod`. Mandar `rnhAreaId` no filtraba nada: el
        // Get devolvia TODAS las areas y el modal mostraba la primera de la lista, no
        // la que se abrio. En un modal de ELIMINAR eso es serio: se confirmaba la baja
        // leyendo un nombre y se borraba otra area.
        const { data: result } = await RNHAreaGet(credentials, { areaCod: row.cod })
        const area = result?.[0] ?? {};

        // El form muestra solo el nombre, que es lo unico que hay que leer para
        // confirmar la baja. La fila es el respaldo si el Get no responde.
        formikRef.current.setValues({
            nombre: area.rnhAreaNombre ?? row?.name ?? "",
        });
        setData(area);
        setIsLoading(false);
    }
    const handleDeleteArea = async (values) => {
        // RNHAreaDel identifica por COD. El cod de la fila es la fuente segura: el del
        // re-Get depende de que la response haya llegado.
        const response = await RNHAreaDel(
            credentials,
            {
                cod: data.rnhAreaCod ?? row?.cod,
                version: data.rnhAreaVersion ?? row?.version,
            }
        );
        if (response.ok) {
            setSnackBarInfo({
                message: "Área eliminada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            setterRowSelected({ status: false, row: {} })
            closeModal();
        } else {
            setSnackBarInfo({
                message: response.error?.mensaje || "No se pudo eliminar el área",
                severity: "error",
                open: true,
            });
        }
    }

    useEffect(() => {
        getArticulosData()
    }, []);
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                })
            }
            onSubmit={(values) => {
                handleDeleteArea(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <>
                        <FormikTextInput
                            fullWidth={true}
                            readOnly
                            name="nombre"
                            labelText="Nombre"
                        />
                    </>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest) && <SpinnerOverlay />}
                </div>
            </Form>
        </Formik>
    );
}
